module.exports = __webpack_public_path__ + "img/training_room-left.af7b8d53.jpg";